export const capitalizeFirstLetter = (string: string): string => {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

// to change a specificLetter you need pass a string and a position in array by its index

export const capitalizeASpecificLetter = (string: string, number: number): string => {
    const selectLetterToUpperCase = string.charAt(number).toUpperCase()
    const specificLetterCapitalize = string.replace(string.charAt(number), selectLetterToUpperCase)
    return specificLetterCapitalize
}
